import {createSlice} from '@reduxjs/toolkit'

import fetchCart from '../thunks/fetchCart'
import updateInCartUpsellPrice from '../thunks/updateInCartUpsellsPrice'
import removeOrderOffer from '../thunks/removeOrderOffer'
import addOrder from '../thunks/addOrder'

const initialState = {
  // Data fetched and for submission
  data: {},
  // Status and error
  status: '',
  error: null,
  // Local state
  upsellToUpdate: null,
  orderOfferIDToRemove: null,
  offerKeyToRemove: null
}

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    changeCartStatus (state, action) {
      state.status = action.payload
    },
    addInCartUpsell (state, action) {
      state.data.cart_data.splice(action.payload.index + 1, 0, {
        ...action.payload.offer,
        campaign_id: state.data.campaign_id,
        order_offer_upsell: null
      })
      state.data.cart_data.find(({id, order_offer_id}) => order_offer_id == action.payload.offer.parent_order_offer_id || id == action.payload.offer.parent_order_offer_id).upsells.shift()

      state.status = 'idle'
    },
    skipInCartUpsell (state, action) {
      state.data.cart_data.forEach(offer => {
        if(offer.id === action.payload) {
          offer.upsells.shift()
        }
      })
    },
    removeInCartUpsell (state, action) {
      state.data.cart_data = state.data.cart_data.filter(({id}) => id !== action.payload)

      state.status = 'idle'
    },
    updateUpsellOfferQuantity (state, action) {
      const {offer, value} = action.payload

      state.data.cart_data.forEach(parent_offer => {
        if(parent_offer.order_offer_id == offer.parent_order_offer_id || parent_offer.id == offer.parent_order_offer_id) {
          parent_offer.upsells[0].order_offer_quantity = value

          state.upsellToUpdate = parent_offer.upsells[0]

          state.status = 'update'
        }
      })
    },
    updateUpsellOfferOption (state, action) {
      const {offer, item_option_id, item_option_value_id} = action.payload

      state.data.cart_data.forEach(parent_offer => {
        if(parent_offer.order_offer_id == offer.parent_order_offer_id || parent_offer.id == offer.parent_order_offer_id) {
          if(!parent_offer.upsells[0].order_offer_item_options) {
            parent_offer.upsells[0].order_offer_item_options = [{
              item_option_id, item_option_value_id
            }]
          } else {
            parent_offer.upsells[0].order_offer_item_options = parent_offer.upsells[0].order_offer_item_options.filter(item_option => item_option.item_option_id !== item_option_id).concat([{
              item_option_id, item_option_value_id
            }])
          }

          state.upsellToUpdate = parent_offer.upsells[0]

          state.status = 'update'
        }
      })
    },
    removeOrderOfferByID (state, action) {
      state.orderOfferIDToRemove = action.payload

      state.data.cart_data = state.data.cart_data.filter(({order_offer_id}) => order_offer_id !== action.payload)

      state.status = 'remove'
    },
    removeOfferByKey (state, action) {
      state.offerKeyToRemove = action.payload

      state.data.cart_data = state.data.cart_data.filter((offer, index) => index !== action.payload)

      state.status = 'remove'
    }
  },
  extraReducers: {
    // fetchCart is for generate_cart
    [fetchCart.pending]: (state) => {
      state.status = 'loading'
    },
    [fetchCart.fulfilled]: (state, action) => {
      state.status = 'succeeded'
      
      state.data = action.payload
    },
    [fetchCart.rejected]: (state, action) => {
      state.status = 'failed'
      if(action.payload) {
        state.error = action.payload.message
      } else {
        state.error = action.error.message
      }
    },
    // Fetch the cart when the order is changed
    'order/changeOrder': (state) => {
      state.status = 'idle'
    },
    [addOrder.fulfilled]: (state) => {
      state.status = 'idle'
    },
    [removeOrderOffer.fulfilled]: (state) => {
      state.orderOfferIDToRemove = null
      state.offerKeyToRemove = null
      state.status = 'idle'
    },
    'discounts/removeDiscount': (state, action) => {
      state.data.cart_data = state.data.cart_data.map((cart_offer) => {
        const {discount_code, subtotal} = cart_offer

        if(discount_code === action.payload) {
          return {
            ...cart_offer,
            discount_code: '',
            discount_label: '',
            total: subtotal
          }
        } else {
          return cart_offer
        }
      })
    },
    // Update the in-cart upsell prices
    [updateInCartUpsellPrice.fulfilled]: (state, action) => {
      const {price, subtotal, total, discount_label} = action.payload
      
      state.data.cart_data.forEach(parent_offer => {
        if(parent_offer.order_offer_id == state.upsellToUpdate.parent_order_offer_id || parent_offer.id == state.upsellToUpdate.parent_order_offer_id) {
          parent_offer.upsells[0] = {...parent_offer.upsells[0], price, subtotal, total, discount_label}
        }
      })

      state.status = 'succeeded'
    },
    // Fetch cart after filling out customer information from PayPal
    'customerInfo/paypalCustomerInfo': (state) => {
      state.status = 'idle'
    },
    // Fetch cart after changing customer information shipping address
    'customerInfo/billToShip': (state) => {
      state.status = 'idle'
    },
    'customerInfo/shipToBill': (state) => {
      state.status = 'idle'
    },
    'customerInfo/resetShip': (state) => {
      state.status = 'idle'
    },
    'customerInfo/selectShipCountry': (state) => {
      state.status = 'idle'
    },
    'customerInfo/selectState': (state) => {
      state.status = 'idle'
    },
    'customerInfo/changeCustomerInfo': (state, action) => {
      if(action.payload.property.indexOf('zipcode') > -1) {
        state.status = 'idle';
      }
    }
  }
})

export const {
  changeCartStatus,
  addInCartUpsell,
  skipInCartUpsell,
  removeInCartUpsell,
  updateUpsellOfferQuantity,
  updateUpsellOfferOption,
  removeOrderOfferByID,
  removeOfferByKey
} = cartSlice.actions

export default cartSlice.reducer


// WEBPACK FOOTER //
// ./client/resources/js/checkout/redux/slices/cartSlice.js